import './masthead.css';

function Masthead() {
  return (
    <div className="wrapper">
    <div className='masthead'>
      <div className="credits">      
        <span>Color theme is <a href='https://github.com/SweetPastel'>SweetPastel</a></span>
        <span>Art by <a href='https://twitter.com/noellemonade'>@noellemonade</a></span>
        <span>Helped by <a href='https://github.com/zeromero-dev'>zeromero</a></span>
      </div>
    </div>
    </div>
  );
}

export default Masthead;
